import React, { useEffect, useState } from "react";
import Layout from "../../../Components/Layout";
import LightText, { BigerTexts } from "../../../Assets/CSS/Text";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

function TeamCreate() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [teamName, setTeamName] = useState("");
  const [teamDescription, setTeamDescription] = useState("");
  const [teamMembersId, setTeamMembersId] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);

  const token = localStorage.getItem("token");

  // Fetch Employee List
  useEffect(() => {
    const featchuser = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/list`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setEmployeeList(response?.data);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    featchuser();
  }, [token]);

  // Fetch Team Data For Edit
  useEffect(() => {
    if (!id) return;

    const fetchTeamData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/teams/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const data = response?.data;

        setTeamName(data?.teamName || "");
        setTeamDescription(data?.teamDescription || "");

        // Convert members into id array
        const memberIds = data?.teamMembers?.map((member) =>
          String(member.empId)
        ) || [];

        setTeamMembersId(memberIds);

        console.log(data, "Edit Team Data");
      } catch (error) {
        console.error("Error fetching team:", error);
      }
    };

    fetchTeamData();
  }, [id, token]);

  // Add Member
  const handleAddMember = (e) => {
    const selectedId = e.target.value;

    if (selectedId && !teamMembersId.includes(selectedId)) {
      setTeamMembersId([...teamMembersId, selectedId]);
    }
  };

  // Remove Member
  const handleRemoveMember = (id) => {
    setTeamMembersId(teamMembersId.filter((member) => member !== id));
  };

  // Create / Update Team
  const handleSubmit = async () => {
    const payload = {
      teamName,
      teamDescription,
      teamMembersId,
    };

    try {
      if (id) {
        // UPDATE TEAM
        await axios.patch(
          `${process.env.REACT_APP_BACKEND_URL}/teams/${id}`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        toast.success("Team updated successfully!");
      } else {
        // CREATE TEAM
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/teams`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        toast.success("Team created successfully!");
      }

      navigate("/teamList");
    } catch (error) {
      console.error("Error saving team:", error);
      toast.error("Something went wrong");
    }
  };

  return (
    <Layout>
      <div className="backgound-main-content" style={{ minHeight: "600px" }}>
        <div className="d-flex gap-2 align-item-center mt-2">
          <h5 style={BigerTexts}>
            {id ? "Edit Team" : "Create New Team"}
          </h5>
        </div>

        <div className="row g-4">
          {/* Team Name */}
          <div className="col-md-6">
            <label className="form-label" style={LightText}>
              Team Name<span className="text-danger">*</span>
            </label>

            <input
              type="text"
              className="form-control"
              style={{
                borderColor: "#C8C8C8",
                borderRadius: "10px",
              }}
              value={teamName}
              onChange={(e) => setTeamName(e.target.value)}
            />
          </div>

          {/* Team Description */}
          <div className="col-md-6">
            <label className="form-label" style={LightText}>
              Team Description
            </label>

            <input
              type="text"
              className="form-control"
              style={{
                borderColor: "#C8C8C8",
                borderRadius: "10px",
              }}
              value={teamDescription}
              onChange={(e) => setTeamDescription(e.target.value)}
            />
          </div>

          {/* Team Members */}
          <div className="col-md-6">
            <label className="form-label" style={LightText}>
              Team Members<span className="text-danger">*</span>
            </label>

            <select
              className="form-select"
              style={{
                borderColor: "#C8C8C8",
                borderRadius: "10px",
              }}
              onChange={handleAddMember}
              defaultValue=""
            >
              <option value="" disabled>
                Select
              </option>

              {employeeList.map((emp) => (
                <option key={emp.empId} value={emp.empId}>
                  {emp.firstName} {emp.lastName}
                </option>
              ))}
            </select>

            {/* Selected Members */}
            <div className="col-md-12">
              <div className="d-flex flex-wrap gap-2 mt-2">
                {teamMembersId.map((id) => {
                  const member = employeeList.find(
                    (emp) => emp.empId === id
                  );

                  return (
                    <span
                      key={id}
                      className="badge rounded-pill bg-light text-dark px-3 py-2"
                      style={{
                        border: "1px solid #ECFAFF",
                        fontWeight: "500",
                      }}
                    >
                      {member
                        ? `${member.firstName} ${member.lastName}`
                        : id}

                      <button
                        type="button"
                        className="btn-close ms-2"
                        onClick={() => handleRemoveMember(id)}
                        style={{ fontSize: "0.6rem" }}
                      ></button>
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex gap-3 mt-4">
          <button
            className="btn border-secondary px-4"
            style={{ color: "#909090" }}
            onClick={() => navigate("/teamList")}
          >
            Cancel
          </button>

          <button
            className="btn px-4"
            style={{
              backgroundColor: "#00AFEF",
              borderRadius: "10px",
              color: "#fff",
            }}
            onClick={handleSubmit}
          >
            {id ? "Update Team" : "+ Create Team"}
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default TeamCreate;